import React from 'react';
import { AuthContext } from './AuthContext';
import { useAuth } from './useAuth';
import type { AuthProviderProps } from './types';

export function AuthProvider({ children }: AuthProviderProps) {
  const auth = useAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}